import { jsx as e } from "react/jsx-runtime";
import { icons as i } from "./icons.js";
const a = ({ name: t, size: o = 24, ...r }) => /* @__PURE__ */ e(
  "svg",
  {
    ...r,
    "data-testid": t,
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    fill: "none",
    viewBox: "0 0 24 24",
    children: i[t]
  }
);
export {
  a as default
};
